import gseedMock from "./gseedMock.json";

const GSEED_MOCK = gseedMock;

export function getGseedMock() {
    return GSEED_MOCK;
}

export function getShowLegacyCo2BySource() {
    return Boolean(GSEED_MOCK?.meta?.showLegacyCo2BySource);
}

export function mergeGseedIntoBuildingInfo(buildingInfo) {
    if (!buildingInfo) return buildingInfo;
    const site = GSEED_MOCK?.site;
    if (!site) return buildingInfo;
    return {
        ...buildingInfo,
        GseedRating: site.gseedRating ?? null,
        GseedScore: site.totalScore ?? null,
        GseedDate: site.certDate ?? null,
        GseedValidUntil: site.validUntil ?? null,
    };
}

export function buildGseedCarbonViewModel() {
    const site = GSEED_MOCK?.site;
    if (!site?.categories?.length) {
        return { hasData: false };
    }

    return {
        hasData: true,
        summary: {
            rating: site.gseedRating ?? "—",
            totalScore: site.totalScore ?? null,
            energyEnvScore: site.energyEnvScore ?? null,
        },
        categories: site.categories.map((c) => ({ ...c })),
    };
}

export function mergeGseedIntoCarbonData(carbonData) {
    if (!carbonData?.values) return carbonData;
    return {
        ...carbonData,
        values: {
            ...carbonData.values,
            gseed: buildGseedCarbonViewModel(),
        },
    };
}
